export const PageSize = 100;

export const countPage = (count) => {
    const product = count % PageSize
    const size = Math.trunc(count / PageSize) + (!!product ? 1 : 0)
    return size
}

export const DEFAULT_LOCATION = {
    lat: 13.984363243687213,
    lng: -89.54855754989579
};

